import { configureStore } from '@reduxjs/toolkit';
import addEnquiryReducer from './slices/addEnquirySlice.js';
import subscriptionReducer from './slices/subscriptionSlice.js';
import subscriptionTierReducer from './slices/subscriptionTierSlice.js';

const store = configureStore({
  reducer: {
    addEnquiry: addEnquiryReducer,
    subscription: subscriptionReducer,
    subscriptionTier: subscriptionTierReducer,
  },
});

export default store;
